import { render, staticRenderFns } from "./CardTable.vue?vue&type=template&id=27796dde&scoped=true"
import script from "./CardTable.vue?vue&type=script&lang=js"
export * from "./CardTable.vue?vue&type=script&lang=js"
import style0 from "./CardTable.vue?vue&type=style&index=0&id=27796dde&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27796dde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27796dde')) {
      api.createRecord('27796dde', component.options)
    } else {
      api.reload('27796dde', component.options)
    }
    module.hot.accept("./CardTable.vue?vue&type=template&id=27796dde&scoped=true", function () {
      api.rerender('27796dde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/material/CardTable.vue"
export default component.exports